import './css/styles.scss';

function startbildPusselInit() {}

startbildPusselInit();
